import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { listDivisionCities, listDivisionStates } from "../endpoints/division";

const DAY = 24 * 60 * 60 * 1000;

/**
 * States/provinces of a country (e.g. "RU"). Region data rarely changes, so
 * cache aggressively. Disabled until a country code is provided.
 */
export function useDivisionStates(countryCode: string | null) {
  return useQuery({
    queryKey: ["divisions", "state", countryCode],
    enabled: !!countryCode,
    queryFn: () => listDivisionStates({ baseUrl: API_BASE_URL }, countryCode as string),
    staleTime: DAY,
  });
}

/**
 * Cities of a state. Disabled until a state id is selected.
 */
export function useDivisionCities(stateId: string | null) {
  return useQuery({
    queryKey: ["divisions", "city", stateId],
    enabled: !!stateId,
    queryFn: () => listDivisionCities({ baseUrl: API_BASE_URL }, stateId as string),
    staleTime: DAY,
  });
}
